import { makeStyles } from '@material-ui/core'
import { grey } from '@material-ui/core/colors'

export const useStyles = makeStyles(theme => ({
  //Estilos Dashboard
  root: {
    '& .MuiTypography-body1': {
      fontWeight: '500'
    }
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    [theme.breakpoints.down('lg')]: {
      // paddingRight: '60px'
    }
  },
  cardSolid: {
    padding: '8px 16px',
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'row',
    minHeight: '150px',
    borderRadius: '20px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    color: theme.palette.primary.contrastText
  },
  cardTitle: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  cardSubtitle: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  superSummaryCard: {
    minHeight: '150px',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#4aa3d6',
    color: theme.palette.white_100.main
  },
  superSummaryTitle: {
    fontSize: '2rem',
    fontWeight: 700,
    textAlign: 'center'
  },
  superSummaryValue: {
    fontSize: '3rem',
    fontWeight: 700,
    lineHeight: 1,
    marginTop: theme.spacing(2)
  },
  systemMetricsCard: {
    minHeight: '220px',
    borderRadius: '16px',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main
  },
  systemMetricsTitle: {
    fontSize: '1rem',
    fontWeight: 700,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  systemMetricsPercent: {
    marginTop: theme.spacing(1),
    fontSize: '1.6rem',
    fontWeight: 700,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  systemMetricsGauge: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  systemMetricsSubtitle: {
    fontSize: '0.9rem',
    fontWeight: 500,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  superConnectionsContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  superConnectionsTitle: {
    fontSize: '1.1rem',
    fontWeight: 700
  },
  superConnectionsSubtitle: {
    fontSize: '0.9rem'
  },
  superConnectionsActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch'
    }
  },
  superConnectionsSelect: {
    minWidth: 360,
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%'
    }
  },

  // Estilos para contagem de chamadas
  boxCountCalls: {
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    gap: '10px'
  },
  card: {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    boxShadow: 'none',
    border:
      '1px solid' +
      (theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_stroke.main),
    borderRadius: '20px',
    fontWeight: '500',
    [theme.breakpoints.up('lg')]: {
      padding: '20px'
    }
  },

  // Cards coloridos
  colorCard1: {
    color: theme.palette.blue_300.main,
    width: 40,
    height: 40,
    [theme.breakpoints.up('lg')]: {
      width: 50,
      height: 50
    }
  },
  colorCard2: {
    color: theme.palette.red_100.main,
    width: 40,
    height: 40,
    [theme.breakpoints.up('lg')]: {
      width: 50,
      height: 50
    }
  },
  colorCard3: {
    color: theme.palette.green_100.main,
    width: 40,
    height: 40,
    [theme.breakpoints.up('lg')]: {
      width: 50,
      height: 50
    }
  },
  colorCard4: {
    color: theme.palette.yellow_400.main,
    width: 40,
    height: 40,
    [theme.breakpoints.up('lg')]: {
      width: 50,
      height: 50
    }
  },
  colorCard5: {
    color: theme.palette.orange_400.main,
    width: 40,
    height: 40,
    [theme.breakpoints.up('lg')]: {
      width: 50,
      height: 50
    }
  },
  colorCard6: {
    color: theme.palette.pink_400.main,
    width: 40,
    height: 40,
    [theme.breakpoints.up('lg')]: {
      width: 50,
      height: 50
    }
  },

  // Informações do servidor
  infoServerContent: {
    display: 'flex',
    gap: '20px'
  },
  infoServerItem: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '8px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontWeight: '500'
  },
  infoServerItemValue: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& svg': {
      color: theme.palette.blue_300.main
    }
  },
  infoServerTitle: {
    fontWeight: '500',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  // Filtros
  filterContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'flex-end'
  },
  selectFormContainer: {
    display: 'flex',
    gap: '8px'
  },
  boxFilter: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '16px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    padding: theme.spacing(2),
    border:
      '1px solid' +
      (theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_stroke.main),
    borderRadius: '20px'
  },
  filters: {
    display: 'flex',
    alignItems: 'end',
    gap: '16px',
    width: '100%'
  },
  fullWidth: {
    width: '100%',
    // background: theme.palette.gray_100?.main,
    height: '38px',
    '& .MuiOutlinedInput-input': {
      padding: '10px'
    }
  },
  buttonFilter: {
    boxShadow: 'none',
    height: '38px',
    background: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    '&:hover': {
      background: theme.palette.blue_400.main,
      boxShadow: 'none'
    }
  },

  // Box de serviços
  boxService: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    height: 245,
    border:
      '1px solid' +
      (theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_stroke.main),
    borderRadius: '20px',
    boxShadow: 'none',
    overflowY: 'auto',
    ...theme.scrollbarStyles
  },

  // Estilos do segundo arquivo mesclado
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    height: 240,
    overflowY: 'auto',
    ...theme.scrollbarStyles
  },

  // Estilos para pagamento PIX
  pixkey: {
    fontSize: '9pt'
  },
  paymentimg: {
    maxWidth: '100%',
    marginTop: '30px'
  },
  paymentpix: {
    maxWidth: '100%',
    maxHeight: '150px',
    padding: '5px',
    backgroundColor: 'white',
    borderColor: 'black',
    borderStyle: 'solid',
    borderWidth: '2px'
  },

  // Estilos para suporte
  supportPaper: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    ...theme.scrollbarStyles
  },
  supportBox: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: '10px',
    textAlign: 'center',
    borderColor: theme.palette.secondary.main,
    borderWidth: '3px',
    borderStyle: 'solid'
  },

  // Estilos para cards
  cardAvatar: {
    fontSize: '55px',
    color: grey[500],
    backgroundColor: '#ffffff',
    width: theme.spacing(7),
    height: theme.spacing(7)
  },

  alignRight: {
    textAlign: 'right'
  },
  selectContainer: {
    width: '100%',
    textAlign: 'left'
  },

  cardGray: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'row',
    height: '100%',
    color: theme.palette.blue_300.main
  },
  cardData: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    zIndex: 1
  },
  cardIcon: {
    width: 100,
    color: theme.palette.primary.light,
    position: 'sticky',
    opacity: 0.4,
    right: 0
  },
  cardRingGraph: {
    width: 100,
    position: 'sticky',
    right: 0
  },

  // Estilos para TicketzPro
  titleChart: {
    color: theme.palette.blue_300?.main || theme.palette.blue_300.main
  },
  ticketzProPaper: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    backgroundColor:
      theme.palette.ticketzproad?.main || theme.palette.blue_300.main,
    color:
      theme.palette.ticketzproad?.contrastText ||
      theme.palette.primary.contrastText,
    ...theme.scrollbarStyles
  },
  ticketzProBox: {
    textAlign: 'center',
    alignContent: 'center'
  },
  ticketzProTitle: {
    fontWeight: 'bold'
  },
  ticketzProScreen: {
    maxHeight: '300px',
    maxWidth: '100%'
  },
  ticketzProFeatures: {
    padding: 0,
    listStyleType: 'none'
  },
  ticketzProCommand: {
    fontFamily: 'monospace',
    backgroundColor: '#00000080'
  },
  clickpointer: {
    cursor: 'pointer'
  }
}))
